module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABUUlEQVQ4jX3TvUscURQF8N8OyyDItDY2IiIhA4sopBaxFfwHhIAJkiIkfiBIyiBimSLgRy+BVPZh/4pMIJUhpLEJ6oSwTLFYzMwyOzvjqS7vnvPePe/e21FDEkaLeI11zBfHv9HHeZylP6r8TkXYxTH20K1fXGCIM+zHWToYXVCIv2KzRr5ChpcIKrlv2IizdFAefqyJ4UucpVtxlm4Xr1axjk8QJGG0gIOGcv+2xCVeJWHUC7Ct2fPzSvysIR/gTYDVhiT0kjAaxS2ctU4SRreYaSHM4gH3xj+xxP+2dpVYkvtvEiP3/uuJCpY1f2CJP135hL1oIbyVz0Eb+p0kjObxU3MnjnCHzyZtDLFSTuIpDmuEAaYL4g3mavmLOEt3ylc/YNH4NE7hGv8axH28Y3KZTvC+xU5Z9gV2x5apimKdd7AmX+dA3qk+LuMs/V7lPwIQYlHMVz5KRwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/icon_warning.png
// module id = 75
// module chunks = 0